import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function EcoActiveIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      ariaHidden="true"
      {...props}
    >
      <g fill={color}>
        <path d="m20.3288 5.13748c-.0907.91274-.2885 2.47054-.7008 4.25449-.3828 1.64423-.8682 3.13513-1.4449 4.43733-.735 1.6546-1.618 3.0085-2.6338 4.0248-1.2557 1.2563-2.9252 1.9458-4.7015 1.9459-1.54664-.0001-3.03225-.5316-4.21645-1.5071-.00786-.0063-.18305-.1476-.39492-.3474 3.00702-5.7779 8.00827-10.35147 14.09237-12.80802z" />
        <path d="m19.7399 3.59998c.1547 0 .3014.05295.4254.15117-6.3599 2.47342-11.62357 7.14015-14.86109 13.07225-1.72182-2.5934-1.41982-6.1132.83671-8.37128 1.01577-1.01627 2.36928-1.90013 4.02308-2.63554 1.3016-.57706 2.7925-1.06761 4.4361-1.44551 2.7802-.64305 5.0097-.76584 5.1398-.77109z" />
        <path d="m4.7437 18.0838c.23406.3157.52756.6048.73418.7957.07638.0705.14834.1318.20859.184-.20377.4393-.39629.8849-.57714 1.3365h-1.44844c.30805-.8132.65186-1.6087 1.02949-2.3848.01795.0227.03508.046.05332.0686z" />
      </g>
    </SVGWrapper>

  );
}

export default EcoActiveIcon;
